import { Button } from "@cieda/djayma-ui";
import { AdminModal } from "@/components/admin/shared/AdminModal";

export interface ActionModalProps {
  readonly open: boolean;
  readonly title: string;
  readonly description: string;
  readonly confirmLabel: string;
  readonly confirmClassName?: string;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
  readonly isPending: boolean;
}

export function ActionModal({
  open,
  title,
  description,
  confirmLabel,
  confirmClassName,
  onClose,
  onConfirm,
  isPending,
}: ActionModalProps) {
  return (
    <AdminModal open={open} onClose={onClose} title={title} size="sm" footer={
      <>
        <Button variant="outline" onClick={onClose} disabled={isPending}>
          Annuler
        </Button>
        <Button onClick={onConfirm} disabled={isPending} className={confirmClassName}>
          {isPending && (
            <span className="mr-1.5 inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
          )}
          {confirmLabel}
        </Button>
      </>
    }>
      <p className="text-sm text-stone-600">{description}</p>
    </AdminModal>
  );
}
